import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function CompactGridTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug p-7" data-testid="resume-live-preview">
      <div className="flex items-baseline justify-between flex-wrap gap-1 border-b-2 pb-3" style={{ borderColor: accent }}>
        <h1 className="text-xl font-bold" style={{ color: accent }}>{draft.full_name || "Your Name"}</h1>
        <p className="text-slate-500 text-[11px]">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" | ")}</p>
      </div>
      {draft.target_role && <p className="text-slate-600 text-xs mt-2 font-semibold">{draft.target_role}</p>}
      {draft.summary && <p className="text-slate-700 mt-3">{draft.summary}</p>}

      <div className="grid grid-cols-2 gap-3 mt-4">
        {draft.skills.length > 0 && (
          <div className="border rounded-lg p-3" style={{ borderColor: `${accent}30` }}>
            <h2 className="text-[11px] font-bold uppercase tracking-wider mb-1.5" style={{ color: accent }}>Skills</h2>
            <p className="text-slate-700 text-[11px]">{draft.skills.join(" • ")}</p>
          </div>
        )}
        {draft.education.length > 0 && (
          <div className="border rounded-lg p-3" style={{ borderColor: `${accent}30` }}>
            <h2 className="text-[11px] font-bold uppercase tracking-wider mb-1.5" style={{ color: accent }}>Education</h2>
            {draft.education.map((ed, i) => <p key={i} className="text-slate-700 text-[11px] mt-1">{ed.degree} {ed.field} — {ed.school}</p>)}
          </div>
        )}
      </div>

      {draft.experience.length > 0 && (
        <div className="mt-4 border rounded-lg p-3" style={{ borderColor: `${accent}30` }}>
          <h2 className="text-[11px] font-bold uppercase tracking-wider mb-1.5" style={{ color: accent }}>Experience</h2>
          {draft.experience.map((e, i) => (
            <div key={i} className="mt-2">
              <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
              <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} variant="boxed" />
    </div>
  );
}
